import { useContext, useEffect, useRef } from "react";
import apiClient from "./apiClient";
import { AppContext } from "../context/AppContext";

/**
 * Registers a SINGLE axios response interceptor to catch 401 globally.
 * Calls logout() once (even if multiple requests 401 at the same time).
 */
export default function AuthInterceptor() {
  const { logout } = useContext(AppContext);
  const loggingOutRef = useRef(false);

  useEffect(() => {
    const id = apiClient.interceptors.response.use(
      (res) => res,
      async (error) => {
        const status = error?.response?.status;

        // Avoid infinite loops: don't trigger logout for auth endpoints
        const url = String(error?.config?.url ?? "");
        const isAuthCall =
          url.includes("auth-login") ||
          url.includes("/auth/") ||
          url.includes("login");

        if (status === 401 && !isAuthCall) {
          if (!loggingOutRef.current) {
            loggingOutRef.current = true;
            try {
              logout(); // should clear token/user and navigate to login
            } finally {
              // small reset window so next session can logout again if needed
              setTimeout(() => {
                loggingOutRef.current = false;
              }, 1000);
            }
          }
        }

        return Promise.reject(error);
      }
    );

    return () => apiClient.interceptors.response.eject(id);
  }, [logout]);

  return null;
}
